import { useEffect, useState } from 'react'
import { Select } from 'antd'
import debounce from 'lodash/debounce'
import { useTranslation } from 'react-i18next'
import { BlockMeetingContent } from 'store/states/lessons.state'
import newUsersList from 'api/administration/users/newList'

interface IProps {
  form?: any
  blockMeeting?: BlockMeetingContent
  disable: boolean
}

const SelectUsers = ({ form, blockMeeting, disable }: IProps) => {
  const [userList, setUserList] = useState([])
  const { t } = useTranslation()
  const fetchList = async (search?: string) => newUsersList(search)

  useEffect(() => {
    fetchList().then(({ data }) => {
      setUserList(data)
    })
  }, [])

  const fetchUser = (value: string) => {
    fetchList(value).then(({ data }) => {
      setUserList(data)
    })
  }

  const handleChange = (value) => {
    const findUser: any = userList.find((user: any) => user.id === value.key)
    form.setValue('host', { name: findUser?.name, email: findUser?.email })
  }

  return (
    <Select
      style={{ width: '100%' }}
      showSearch
      allowClear
      labelInValue
      disabled={disable}
      placeholder={t('administration.blocks.type.meeting.host.placeholder')}
      filterOption={false}
      onSearch={debounce(fetchUser, 500)}
      onChange={handleChange}
      defaultValue={
        blockMeeting?.config?.host
          ? {
              key: `${blockMeeting?.config?.host?.name} (${blockMeeting?.config?.host?.email})`,
            }
          : { key: '' }
      }
    >
      {userList?.map((user: any) => (
        <Select.Option key={user?.id} value={user?.id}>
          {`${user?.name} (${user?.email})`}
        </Select.Option>
      ))}
    </Select>
  )
}

export default SelectUsers
